import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";
import { AppProvider } from "@/lib/app-context";
import { Header } from "@/components/ww/Header";
import { Footer } from "@/components/ww/Footer";
import { SignupModal } from "@/components/ww/SignupModal";
import { CookieBanner, RequireAuth, WelcomeDialog } from "@/components/ww/Misc";
import Home from "@/pages/Home";
import AuthPage from "@/pages/AuthPage";
import Wallet from "@/pages/Wallet";
import ProductForm from "@/pages/ProductForm";
import ProductDetail from "@/pages/ProductDetail";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";
import FamilyJoin from "@/pages/FamilyJoin";
import SharedWallet from "@/pages/SharedWallet";
import SharedProduct from "@/pages/SharedProduct";
import { ContactPage, LegalPage, PricingPage } from "@/pages/Static";

const TITLES = { "/": "Warranty Wallet — Digital Warranty Wallet & Warranty Expiry Reminder", "/pricing": "Pricing — Warranty Wallet", "/wallet": "My Wallet — Warranty Wallet", "/add": "Add Product — Warranty Wallet", "/account": "Account — Warranty Wallet" };

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = TITLES[pathname] || "Warranty Wallet — Every Purchase. Every Promise. One Wallet.";
  }, [pathname]);
  return null;
}

const P = (el) => <RequireAuth>{el}</RequireAuth>;

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppProvider>
          <ScrollTop />
          <div className="flex min-h-screen flex-col bg-ww-bg font-body text-ww-navy">
            <Header />
            <div className="flex-1">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/sign-in/*" element={<AuthPage mode="sign-in" />} />
                <Route path="/sign-up/*" element={<AuthPage mode="sign-up" />} />
                <Route path="/wallet" element={P(<Wallet />)} />
                <Route path="/add" element={P(<ProductForm />)} />
                <Route path="/products/:id" element={P(<ProductDetail />)} />
                <Route path="/products/:id/edit" element={P(<ProductForm />)} />
                <Route path="/account" element={P(<Account />)} />
                <Route path="/admin" element={P(<Admin />)} />
                <Route path="/family/join" element={<FamilyJoin />} />
                <Route path="/shared/:ownerId" element={P(<SharedWallet />)} />
                <Route path="/shared/:ownerId/products/:id" element={P(<SharedProduct />)} />
                <Route path="/shared/:ownerId/add" element={P(<ProductForm key="shared-add" />)} />
                <Route path="/shared/:ownerId/products/:id/edit" element={P(<ProductForm key="shared-edit" />)} />
                <Route path="/pricing" element={<PricingPage />} />
                <Route path="/contact" element={<ContactPage />} />
                {["about", "privacy", "terms", "refund-policy", "data-deletion"].map((s) => <Route key={s} path={`/${s}`} element={<LegalPage slug={s} />} />)}
                <Route path="*" element={<LegalPage slug="about" />} />
              </Routes>
            </div>
            <Footer />
          </div>
          <SignupModal />
          <WelcomeDialog />
          <CookieBanner />
          <Toaster position="top-center" richColors />
        </AppProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
